import {afterSigninPath, Otp, OTP_LENGTH, REDIRECT, signIn, SUCCESS_REPONSE_CODE, toastr, 
        handleOtherResponseCode, UNPROCESSABLE_ENTITY_RESPONSE_CODE, CustomToastrAction} from '@/imports-files/pages/admins/otp';

export async function handleOtpSubmit(...params) {

  // ---------------------------- Initialization ------------------------------
    const userType            =   params[0].userType
    const body                =   {
                                    code: params[0].value.otp,
                                    access_token: params[0].token,
                                    user_type: userType
                                  };
    const result              =   await new Otp().verifyOtp(JSON.stringify(body));
    const status_code         =   result.status || result.response.status;
    const router              =   params[0].router;
    const t                   =   params[0].translation;
    const updateUser          =   params[0].updateUser;
    const setDisabled         =   params[0].setDisabled
    const customToastrAction  =   new CustomToastrAction(); 
  // ---------------------------- Initialization ------------------------------

       setDisabled(true);
   // ---------------------------- Handling Response ---------------------------
       switch(status_code)
       {
        case SUCCESS_REPONSE_CODE:
          const response = result.data
          if (response.success)
          {
            updateUser(response);
            await signIn('credentials', {redirect: false, body: JSON.stringify(response)});
            // toastr.success(t('page:admins:otp_verify:success:otp_verified'));
            afterSigninPath(router, response);
          }
          else if (response.error)
          {
            if( response.remaining_attempts > 0)
            {
              if(response.expired)
              {
                customToastrAction.setNormalToastr(response.error, 'warning');
                // toastr.warning(response.error);
              }
              else
              {
                let error_mess = t('common:errors:attempts_left');
                error_mess = error_mess.replace("Number", response.remaining_attempts);
                customToastrAction.setNormalToastr(error_mess, 'warning');
                // toastr.warning(error_mess);
              } 
            }
            else
            {
              if (router.pathname.includes('admins')) {
                router.push(REDIRECT.admins.login)
              }
              else if(router.pathname.includes('clients'))
              {
                router.push(REDIRECT.client.login)
              }
              else if(router.pathname.includes('agency'))
              {
                router.push(REDIRECT.agency.welcome)
              }
              customToastrAction.setNormalToastr(t('common:errors:acc_blocked'), 'warning');
              // toastr.warning(t('common:errors:acc_blocked'));
            }
          }
        break;
        default:
          handleOtherResponseCode(status_code, router)
       }

       setDisabled(false);
  // ---------------------------- Handling Response ---------------------------
}

export async function handleResendEvent(access_token, restart, router, set_status, updateUser, setAccessToken) {
  // ---------------------------- Initialization ------------------------------
  const body                =   { access_token: access_token };
  const result              =   await new Otp().resendOtp(body);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 
  // ---------------------------- Initialization ------------------------------

  switch(status_code){
    case SUCCESS_REPONSE_CODE:
      let response = result.data
     
      updateUser(response);
      customToastrAction.setNormalToastr(response.success, 'success');
      // toastr.success(response.success);
      setAccessToken(response.access_token)
      const expiry_time = get_seconds_for_timer(response.expires_at);
      const time = new Date();
      time.setSeconds(time.getSeconds() + expiry_time);
      set_status(true);
      restart(time);
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      if (result.error) 
      {
        customToastrAction.setNormalToastr(result.error, 'warning');
        // toastr.warning(result.error);
        router.pathname.includes("admins") ? router.push(REDIRECT.admins.login) : router.push(REDIRECT.client.login);
      }
      break;
    default: 
      handleOtherResponseCode(status_code, router)
  }
}

export function get_seconds_for_timer(expire_time) {
  const token_exp_time = new Date(expire_time).getTime();
  const current_time = new Date().getTime();
  let time_left = token_exp_time - current_time;
  time_left = time_left < 0 ? 0 : parseInt(time_left/1000);
  return time_left;
}

export function handleOtpChange(event, formik) {
  if (event.target.value.length <= OTP_LENGTH) {
    formik.setFieldValue('otp', event.target.value.replace(/[^0-9]/g, ''));
  }
}


export function setRedirectUserType(userType)
{
  switch(userType)
  {
    // case 'ClientUser': return REDIRECT.client.login;
    case 'Admin'     : return REDIRECT.admins.login;
    case 'AgencyUser': return REDIRECT.agency.welcome;
    default: return REDIRECT.admins.login;
  }
}

export function setUserType(userType)
{
  switch(userType)
  {
    case 'ClientUser': return 'ClientUser';
    case 'Admin'     : return 'Admin';
    case 'AgencyUser': return 'AgencyUser';
    default: return 'Admin';
  }
}